<template>
    <div class="nav-bar">
        <!-- <div class="nav-item">旧址入口</div> -->
        <a class="nav-item" href="https://mail.nenu.edu.cn">邮箱入口</a>
        <a class="nav-item" href="https://www.nenu.edu.cn">学校主页</a>
    </div>
</template>

<script  type="text/javascript">
export default {
    name: "navBar",
    data() {
        return{

        }
    }
}
</script>
<style lang="less">
    .nav-bar{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 60px;
        width: 90%;
        position: relative;
        z-index: 333;
    }
    .nav-item{
        font-size: 1.2rem;
        color: #666;
        padding: 0 30px;
        position: relative;
        font-family: DemiLightff;
        &:after{
            content: '';
            width: 1px;
            height: 10px;
            background: #999;
            position: absolute;
            right: 0;
            top: 0;
        }
        &:last-child:after{
            display: none;
        }
    }
</style>